// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GxC0x","title":"styles_title__184d2"};